import { qs, qsa } from "../inc/dom.js";

const initResources = () => {
    const items = qsa("[data-resource-item]");
    if (!items.length) return;
    const buttons = qsa("[data-resource-filter]");
    const select = qs("[data-resource-select]");
    const search = qs("[data-resource-search]");
    const form = qs("[data-resource-searchform]");
    const empty = qs("[data-resource-empty]");

    let type = "";
    let term = "";

    const matches = (item) => {
        if (type && item.dataset.resourceType !== type) return false;
        if (term && !(item.dataset.resourceSearch || "").includes(term)) return false;
        return true;
    };

    const render = () => {
        let shown = 0;
        items.forEach((item) => {
            const visible = matches(item);
            item.hidden = !visible;
            if (visible) shown += 1;
        });
        if (empty) empty.hidden = shown !== 0;
        buttons.forEach((button) => {
            button.classList.toggle("is-active", button.dataset.resourceFilter === type);
        });
        if (select && select.value !== type) select.value = type;
    };

    buttons.forEach((button) => {
        button.addEventListener("click", (event) => {
            event.preventDefault();
            type = button.dataset.resourceFilter || "";
            render();
        });
    });

    if (select) {
        select.addEventListener("change", () => {
            type = select.value;
            render();
        });
    }

    if (form) form.addEventListener("submit", (event) => event.preventDefault());

    if (search) {
        search.addEventListener("input", () => {
            term = search.value.trim().toLowerCase();
            render();
        });
    }

    render();
};

initResources();
